export default __webpack_public_path__ + "app/assets/images/job_offer/thumbnail-inhouse-a69765c4e8ac9e07b759b0bfe011315f.jpg";